<template>
    <!-- Pick from the list, chosen people as gray chips underneath (shared .tag-chips styles in style.scss) -->
    <div class="owner-picker">
        <select v-if="available.length" :value="''" @change="add($event)">
            <option value="">Add a person&hellip;</option>
            <option v-for="u in available" :key="u.UserID" :value="u.UserID">{{ u.FirstName }} {{ u.LastName }}</option>
        </select>
        <div v-if="selected.length" class="tag-chips">
            <span v-for="u in selected" :key="u.UserID" class="tag-chip">
                {{ u.FirstName }} {{ u.LastName }}
                <button type="button" class="tag-chip-x" :aria-label="'Remove ' + u.FirstName + ' ' + u.LastName" title="Remove" @click="remove(u.UserID)"><svg-icon icon="x" /></button>
            </span>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';

// Picks process owners from the company's admin users ($store.state.users).
// v-model is an array of tblUser UserIDs, the shape saved to ProcessOwnersJSON.
export default defineComponent({
    name: 'ProcessOwnerPicker',
    props: {
        modelValue: { type: Array, default: () => [] }
    },
    emits: ['update:modelValue'],
    components: {
        SvgIcon
    },
    computed: {
        users(): any[] {
            return this.$store.state.users || [];
        },
        selected(): any[] {
            return (this.modelValue as number[])
                .map(id => this.users.find((u: any) => u.UserID == id))
                .filter(Boolean);
        },
        available(): any[] {
            return this.users.filter((u: any) => !(this.modelValue as number[]).some(id => id == u.UserID));
        }
    },
    methods: {
        add(event: any) {
            const id = parseInt(event.target.value);
            event.target.value = '';
            if(id) {
                this.$emit('update:modelValue', [...(this.modelValue as number[]), id]);
            }
        },
        remove(id: number) {
            this.$emit('update:modelValue', (this.modelValue as number[]).filter(o => o != id));
        }
    }
});
</script>

<style scoped>
.owner-picker select { margin: 0; }
</style>
